import { useEffect as o, useState as l } from "react";
const f = ({
  onSearch: s,
  disableReset: r = !1,
  showMenu: n
}) => {
  o(() => {
    c();
  }, [n]);
  const [e, h] = l(""), a = (t) => {
    h(t), s?.(t);
  }, c = () => {
    a("");
  };
  return {
    searchValue: e,
    handleSearch: a,
    handleResetSearchField: c,
    canResetSearchValue: !!e && !r
  };
};
export {
  f as useSearch
};
